import React from "react";
import { Helmet } from "react-helmet";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Container, Accordion, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const faqs = [
    {
        section: "EMI Application Process",
        question: "How do I apply for EMI with DBS?",
        answer:
            "You can apply for EMI during checkout. Select DBS as your payment option and complete the authorization form.",
    },
    {
        section: "EMI Application Process",
        question: "What documents are required for EMI application?",
        answer:
            "You’ll need a valid ID (NRIC/FIN/Passport), invoice number, and completed GIRO form.",
    },
    {
        section: "Return & Refund Policy",
        question: "What is your return policy?",
        answer:
            "We accept returns within 7 days of delivery for unopened and undamaged items.",
    },
    {
        section: "Return & Refund Policy",
        question: "How long does it take to get a refund?",
        answer:
            "Refunds are processed within 7–10 business days after the return is approved.",
    },
    {
        section: "Troubleshooting Login Issues",
        question: "I forgot my password. What should I do?",
        answer:
            "Click on ‘Forgot password’ on the login page and follow the instructions sent to your email.",
    },
    {
        section: "Troubleshooting Login Issues",
        question: "I’m not receiving the OTP or email verification.",
        answer:
            "Please check your spam folder or ensure your email/phone number is entered correctly.",
    },
    {
        section: "DBS EMI Processing Details",
        question: "How long does it take for DBS EMI to activate?",
        answer:
            "DBS typically processes GIRO applications within 5–7 working days.",
    },
    {
        section: "DBS EMI Processing Details",
        question: "Can I change my EMI plan after approval?",
        answer:
            "EMI plans cannot be modified after DBS approval. Please contact support for further options.",
    },
];

const Help = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Helmet>
                <title>Help Center | AZZ</title>
                <meta
                    name="description"
                    content="Find answers to common questions and support topics"
                />
            </Helmet>

            <NavBar />

            <main className="flex-grow-1">
                <section className="bg-light py-5 border-bottom">
                    <Container className="text-center">
                        <h1 className="fw-bold display-5 mb-2">
                            Frequently asked questions
                        </h1>
                        <p className="text-muted fs-5">
                            These are the most common questions about AZZ EMI and policies.
                            Can’t find what you’re looking for?{" "}
                            <Button variant="none" as={Link} to="/contact" className="fw-semibold text-decoration-underline">
                                Chat to our friendly team!
                            </Button>
                        </p>
                    </Container>
                </section>

                <section className="py-5">
                    <Container>
                        {Object.entries(
                            faqs.reduce((acc, cur) => {
                                acc[cur.section] = acc[cur.section] || [];
                                acc[cur.section].push(cur);
                                return acc;
                            }, {})
                        ).map(([section, items], sIndex) => (
                            <div key={sIndex} className="mb-5">
                                <h4 className="fw-bold mb-4">{section}</h4>
                                <Accordion>
                                    {items.map((faq, i) => (
                                        <Accordion.Item
                                            eventKey={`${sIndex}-${i}`}
                                            key={faq.question}
                                        >
                                            <Accordion.Header>
                                                <span className="fw-semibold text-muted">{faq.question}</span>
                                            </Accordion.Header>
                                            <Accordion.Body>{faq.answer}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        ))}
                    </Container>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Help;